const React = require("react");
const Injector = require("../decorators/Injector");

const Auth = require("services/Auth");

@Injector([])
class Can extends React.Component {

    get has_access(){

        const result = (function() {

            if(this.props.force === true){
                return true;
            }

            if(typeof(this.props.hasOwnShop) !== 'undefined'){
                return Auth.hasOwnShop === this.props.hasOwnShop;
            }

            if (this.props.canManageShops === true) {
                return Auth.canManageShops;
            } else if (this.props.canManageShops === false) {
                return !Auth.canManageShops;
            }
            
            if (this.props.canPerformDeliveryRuleActions === true) {
              return Auth.canPerformDeliveryRuleActions;
            } else if (this.props.canPerformDeliveryRuleActions === false) {
              return !Auth.canPerformDeliveryRuleActions;
            }
            

            if (this.props.isBloomitVip === true) {
                return Auth.isBloomitVip;
            } else if (this.props.isBloomitVip === false) {
                return !Auth.isBloomitVip;
            }

            if(this.props.impersonating === true){
                return Auth.impersonating;
            }

            if(this.props.operation){

                if(this.props.resource){

                    if(this.props.item){
                        return Auth.can(this.props.operation, this.props.resource, this.props.item);
                    } else {
                        return Auth.can(this.props.operation, this.props.resource);
                    }

                }

            }

            return false;

        }.bind(this))();

        return this.props.invert ? !result : result;
    }

    render() {
        if(this.has_access){
            return this.props.children;
        }

        return null;
    }

}

module.exports = Can;
